export function entitlementRefreshDelay(
  entitlement: { status: string; expires_at: string } | null | undefined,
  now = Date.now(),
): number | null {
  if (!entitlement || entitlement.status === 'expired') return null
  const delay = new Date(entitlement.expires_at).getTime() - now + 250
  if (!Number.isFinite(delay)) return null
  return Math.max(0, delay)
}
